import styled from 'styled-components';

export const ReplyContainer = styled.div`
  border-left: 3px solid #5e72e4;
  background: #f1f4fb;
  padding: 8px 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #4a4a4a;
`;

export const ReplyHeader = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 0.85rem;
`;

export const ReplyMeta = styled.div`
  font-size: 0.75rem;
  color: #7d7d7d;
  margin-bottom: 6px;
  span {
    font-weight: bold;
  }
`;

export const ReplyRecipientsList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const ReplyRecipientItem = styled.span`
  background: #e7f3ff;
  color: #0066cc;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 0.7rem;
  border: 1px solid #b3d9ff;
`;

export const ReplyContent = styled.div`
  font-size: 0.85rem;
  color: #333;
  max-height: 4.5em;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease;

  &.expanded {
    max-height: 31.25rem;
  }

  p {
    margin: 0;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const ToggleExpand = styled.div`
  font-size: 0.75rem;
  color: #5e72e4;
  cursor: pointer;
  margin-top: 6px;
  user-select: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const ReplyAttachments = styled.div`
  margin-top: 6px;
  font-size: 0.75rem;
  color: #5e72e4;
`;
